import { Button, Card } from "react-bootstrap";
import { CheckCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Passwordsuccess = () => {
  const navigate = useNavigate();
  // State for button hover effect
  const [isHovered, setIsHovered] = useState(false);

  // Placeholder for resend functionality
  const handleResend = () => {
    console.log("Resend password reset instructions");
    // Add resend logic here
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/"); // 👈 redirect to your target route
    }, 5000); // 5000ms = 5 seconds

    // Optional: clear timeout if component unmounts before timeout completes
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Card
        style={{
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          borderRadius: "1.5rem",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <Card.Body
          style={{
            padding: "1.5rem",
            textAlign: "center",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "1rem",
            }}
          >
            <div style={{ position: "relative", display: "inline-block" }}>
              <div
                style={{
                  width: "4rem",
                  height: "4rem",
                  background:
                    "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  borderRadius: "1.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
                  transform: "rotate(0deg)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <CheckCircle size={32} style={{ color: "#ffffff" }} />
              </div>
              <div
                style={{
                  position: "absolute",
                  inset: "-0.5rem",
                  background:
                    "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  borderRadius: "1.5rem",
                  filter: "blur(20px)",
                  opacity: 0.3,
                }}
              ></div>
            </div>
          </div>

          <h2
            style={{
              fontSize: "1.75rem",
              fontWeight: 700,
              color: "#1e293b",
              marginBottom: "1rem",
            }}
          >
            Password Reset!
          </h2>
          <p
            style={{
              color: "#64748b",
              fontSize: "0.875rem",
              lineHeight: 1.6,
              marginBottom: "1rem",
            }}
          >
            Your password has been successfully reset.
          </p>

          <Link to="/forgot-password">
            <Button
              variant="link"
              onClick={handleResend}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                color: isHovered ? "#7c3aed" : "#8b5cf6",
                fontWeight: 600,
                textDecoration: "none",
                fontSize: "0.875rem",
                transition: "color 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                border: "none",
                background: "none",
                padding: 0,
              }}
            >
              Send again
            </Button>
          </Link>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Passwordsuccess;
